const TwoCubes = () => {
  return (
    <svg width="90" height="90" viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M85 23.4737L60 36.9475L35 23.4737L60 10L85 23.4737Z" fill="url(#paint0_linear_1_1102)"/>
      <path d="M85 50.4145L60 63.8882V36.9474L85 23.4737V50.4145Z" fill="url(#paint1_linear_1_1102)"/>
      <path d="M60 63.8882L35 50.4145V23.4737L60 36.9474V63.8882Z" fill="url(#paint2_linear_1_1102)"/>
      <path d="M60.3262 37.2593L60 63.8881V36.9473L60.3262 37.2593Z" fill="#04BB8B"/>
      <path d="M85 23.4737L60 36.9474L60.3262 37.2593L85 23.4737Z" fill="#04BB8B"/>
      <path opacity="0.75" d="M60 36.9474L35 23.4737L59.534 37.2593L60 63.8882V36.9474Z" fill="#04BB8B"/>
      <g clipPath="url(#clip0_1_1102)">
        <path d="M55 40.4737L30 53.9475L5 40.4737L30 27L55 40.4737Z" fill="url(#paint3_linear_1_1102)"/>
        <path d="M55 67.4145L30 80.8883V53.9474L55 40.4737V67.4145Z" fill="url(#paint4_linear_1_1102)"/>
        <path d="M30 80.8883L5 67.4145V40.4737L30 53.9474V80.8883Z" fill="url(#paint5_linear_1_1102)"/>
        <path d="M30.3262 54.2594L30 80.8883V53.9474L30.3262 54.2594Z" fill="#3F75EA"/>
        <path d="M55 40.4737L30 53.9475L30.3262 54.2594L55 40.4737Z" fill="url(#paint6_linear_1_1102)"/>
        <path opacity="0.76" d="M30 53.9474L5 40.4737L29.534 54.2594L30 80.8883V53.9474Z" fill="#3F75EA"/>
        <path opacity="0.44" d="M5 40.4737L29.534 54.2594L30 80.8883L5 67.4212V40.4737Z" fill="url(#paint7_linear_1_1102)"/>
      </g>
      <defs>
        <linearGradient id="paint0_linear_1_1102" x1="25.0109" y1="3.54973" x2="74.1682" y2="31.7145" gradientUnits="userSpaceOnUse">
          <stop offset="0.0575" stopColor="#2E3386"/>
          <stop offset="0.2313" stopColor="#2E3986"/>
          <stop offset="0.457" stopColor="#2C4986"/>
          <stop offset="0.7101" stopColor="#2A6485"/>
          <stop offset="0.9041" stopColor="#287D85"/>
        </linearGradient>
        <linearGradient id="paint1_linear_1_1102" x1="54.6257" y1="71.3465" x2="87.1841" y2="20.6454" gradientUnits="userSpaceOnUse">
          <stop offset="0.2691" stopColor="#005B71"/>
          <stop offset="0.3379" stopColor="#006774"/>
          <stop offset="0.7146" stopColor="#03A385"/>
          <stop offset="0.8941" stopColor="#04BB8B"/>
        </linearGradient>
        <linearGradient id="paint2_linear_1_1102" x1="35.8096" y1="50.6157" x2="61.7477" y2="35.1365" gradientUnits="userSpaceOnUse">
          <stop stopColor="#015576"/>
          <stop offset="0.9573" stopColor="#113B62"/>
        </linearGradient>
        <linearGradient id="paint3_linear_1_1102" x1="-1.18882" y1="22.7138" x2="47.9684" y2="50.8785" gradientUnits="userSpaceOnUse">
          <stop offset="0.323" stopColor="#2E074F"/>
          <stop offset="0.4405" stopColor="#330A55"/>
          <stop offset="0.593" stopColor="#421465"/>
          <stop offset="0.764" stopColor="#5B2480"/>
          <stop offset="0.8562" stopColor="#6B2F91"/>
        </linearGradient>
        <linearGradient id="paint4_linear_1_1102" x1="31.8993" y1="77.0895" x2="57.0224" y2="37.9668" gradientUnits="userSpaceOnUse">
          <stop offset="0.0156" stopColor="#253E81"/>
          <stop offset="0.4345" stopColor="#6B2F91"/>
          <stop offset="0.5107" stopColor="#713090"/>
          <stop offset="0.6145" stopColor="#83328C"/>
          <stop offset="0.7342" stopColor="#9F3587"/>
          <stop offset="0.8648" stopColor="#C73A7F"/>
          <stop offset="0.9799" stopColor="#F03F77"/>
        </linearGradient>
        <linearGradient id="paint5_linear_1_1102" x1="25.387" y1="53.6824" x2="-15.4468" y2="90.1467" gradientUnits="userSpaceOnUse">
          <stop offset="0.0816" stopColor="#2E074F"/>
          <stop offset="0.2321" stopColor="#280648"/>
          <stop offset="0.4467" stopColor="#190536"/>
          <stop offset="0.661" stopColor="#03031C"/>
        </linearGradient>
        <linearGradient id="paint6_linear_1_1102" x1="33.0507" y1="52.5022" x2="55.3198" y2="40.0824" gradientUnits="userSpaceOnUse">
          <stop offset="0.1456" stopColor="#3F75EA"/>
          <stop offset="0.9674" stopColor="#6B2F91" stopOpacity="0"/>
        </linearGradient>
        <linearGradient id="paint7_linear_1_1102" x1="-4.42124" y1="75.3875" x2="27.8071" y2="53.6342" gradientUnits="userSpaceOnUse">
          <stop offset="0.2741" stopColor="#AD3784"/>
          <stop offset="0.42" stopColor="#952E79" stopOpacity="0.7785"/>
          <stop offset="0.7271" stopColor="#56175D" stopOpacity="0.3122"/>
          <stop offset="0.9328" stopColor="#290749" stopOpacity="0"/>
        </linearGradient>
        <clipPath id="clip0_1_1102">
          <rect width="50" height="54" fill="white" transform="translate(5 27)"/>
        </clipPath>
      </defs>
    </svg>
  );
}

export default TwoCubes;
